<template>
  <div>
    <FormWizardStepHeader
      title="How did you hear about The Hub?"
      description="Select an option below"
    />

    <AlertSlideUpDown :show="$v.source.$error"
      >Please choose how you heard about The hub</AlertSlideUpDown
    >

    <FormItem>
      <b-form-radio-group
        v-model="form.source"
        buttons
        class="btn-group-outline-spaced-big mb-20"
        @input="$v.source.$touch()"
      >
        <b-form-radio
          v-for="option in options"
          :key="option.value"
          :value="option.value"
          >{{ option.label }}</b-form-radio
        >
      </b-form-radio-group>
    </FormItem>

    <FormItem
      v-if="form.source === 'other'"
      label="Specify where you heard about The Hub"
      invalid-message="Please specify where you heard about The Hub"
      :state="$v.sourceText.$dirty ? !$v.sourceText.$error : null"
    >
      <b-form-input
        v-model="form.sourceText"
        :state="$v.sourceText.$dirty ? !$v.sourceText.$error : null"
        placeholder="Enter answer here"
        @blur="$v.sourceText.$touch()"
      />
    </FormItem>
  </div>
</template>

<script>
import FormItem from '@/components/form/FormItem/index'
import FormWizardStepHeader from '@/components/FormWizardStepHeader'
import AlertSlideUpDown from '@/components/AlertSlideUpDown'

export default {
  name: 'CompanyFormStepUserSource',
  components: {
    AlertSlideUpDown,
    FormWizardStepHeader,
    FormItem
  },
  props: {
    $v: {
      type: Object,
      required: true
    },
    value: {
      type: Object
    }
  },
  data() {
    return {
      form: {
        ...this.value
      },
      options: [
        { value: 'google-search', label: 'Google Search' },
        {
          value: 'social-media',
          label: 'Social Media ( Facebook, LinkedIn etc. )'
        },
        { value: 'friend', label: 'A Friend' },
        { value: 'offline-event', label: 'Offline Event' },
        { value: 'other', label: 'Other (specify)' }
      ]
    }
  },
  watch: {
    value(newValue) {
      this.form = newValue
    },
    form: {
      deep: true,
      handler() {
        this.$emit('input', this.form)
      }
    }
  }
}
</script>
